import React, { useMemo } from 'react';
import useCompareChartSettings from '../../../../utils/compareChartSettings';
import { PrimaryButton } from '../../../Button';
import useSaveReportSettings from '../../utils/useSaveReportSettings';
import { useChartContext } from '../../ChartContext';
import KubitTooltip from '../../../KubitTooltip';
import { assertCondition } from '../../../../utils/types';
interface Props {
  analysisId: string;
}

const SaveButton = ({ analysisId }: Props) => {
  const chartContext = useChartContext();
  assertCondition(chartContext.__typename === 'BaseChartContext');
  const {
    permissions: { entityPermissions, entityPermissionsHint },
  } = chartContext;
  const hasSettingsChanged = useCompareChartSettings(analysisId);

  const { saveReportSettings } = useSaveReportSettings(analysisId);

  const content = useMemo(() => {
    if (!entityPermissions.editAnalysis) {
      return entityPermissionsHint.editAnalysis;
    }

    if (!hasSettingsChanged) {
      return `No changes to save`;
    }

    return 'Save report settings';
  }, [
    entityPermissions.editAnalysis,
    entityPermissionsHint.editAnalysis,
    hasSettingsChanged,
  ]);

  return (
    <KubitTooltip placement="bottom-end" content={content}>
      <PrimaryButton
        disabled={!(hasSettingsChanged && entityPermissions.editAnalysis)}
        onClick={saveReportSettings}
        trackContext="reports"
        trackAction="save settings"
      >
        Save
      </PrimaryButton>
    </KubitTooltip>
  );
};

export default SaveButton;
